import { config } from "~/config";
import { isAuthenticated } from "~/stores/auth";

export function createFrameContent(styles: string, scripts: string, isProtected: boolean) {
	const auth = !isAuthenticated() && isProtected;

	return `
		<html class="web">
		<head>
			<style>
			html {
				overflow: hidden;
				overflow-x: auto;
			}
		
			body {
				margin: 0;
				padding: 0;
				display: flex;
			}
			</style>
			<base target="_blank">
			${
				auth
					? `
				<style>
					#article-protected {
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						border-radius: 12px;
						height: 400px;
						width: 100vw;
						background-color: #f5f5f5;
						font-family: Arial, sans-serif;
					}

					#lock-alert {
						width: 2rem;
						height: 2rem;
					}
				</style>
			`
					: `
				${styles}
				${scripts}
			`
			}
			<script src="https://cdnjs.cloudflare.com/ajax/libs/mark.js/8.11.1/mark.min.js"></script>
		</head>
		<body>
			${
				auth
					? `
				<div id="article-protected">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="lock-alert">
						<title>lock-alert</title>
						<path d="M10 17C11.1 17 12 16.1 12 15C12 13.9 11.1 13 10 13C8.9 13 8 13.9 8 15S8.9 17 10 17M16 8C17.1 8 18 8.9 18 10V20C18 21.1 17.1 22 16 22H4C2.9 22 2 21.1 2 20V10C2 8.9 2.9 8 4 8H5V6C5 3.2 7.2 1 10 1S15 3.2 15 6V8H16M10 3C8.3 3 7 4.3 7 6V8H13V6C13 4.3 11.7 3 10 3M22 13H20V7H22V13M22 17H20V15H22V17Z" />
					</svg>
					<p>Inloggen is vereist om dit artikel te kunnen bekijken.</p>
				</div>
			`
					: "<div id='article-content'></div>"
			}
		</body>
		<script>

			const handle = (e) => {
				if (e.target.tagName === 'A') {
					e.preventDefault();

					window.parent.postMessage({
						source: 'document-viewer',
						href: e.target.href
					});
				}
			}

			document.body.addEventListener('click', handle);
			document.body.addEventListener('beforeunload', () => {
				document.body.removeEventListener('click', handle);
			});
		</script>
		</html>
	`;
}

export function getArticleParam() {
	return new URL(window.location.href).searchParams.get("article") || "";
}

export function setArticleParam(objectId: string | undefined) {
	if (!objectId) {
		return;
	}

	const url = new URL(window.location.href);
	const hasArticle = url.searchParams.has("article");

	if (hasArticle && url.searchParams.get("article") === objectId) {
		return;
	}

	url.searchParams.set("article", objectId);

	if (hasArticle) {
		window.history.pushState({}, "", url);
	} else {
		window.history.replaceState({}, "", url);
	}
}

/**
 * Check if any of the queries match any of the tests
 */
export function matchSearch(group: string[], tests: string[]) {
	if (group.length === 0) {
		return true;
	}

	const lowerCasedTests = tests.map((x) => x.toLowerCase());

	for (const query of group) {
		for (const test of lowerCasedTests) {
			if (test.includes(query)) {
				return true;
			}
		}
	}

	return false;
}

export function isDocumentLink(url: string, documentId: string): boolean {
	const DOCUMENT_REGEX = new RegExp(`https://${config.deepLinkEndpoint}/articles/${documentId}/.*`);
	return DOCUMENT_REGEX.test(url);
}

export function isMeerInfoLink(url: string): boolean {
	return url.startsWith("meerinfo://");
}
